import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { stepsConfig, StepId } from "../step-config";

// Map old numeric step params to new step IDs for backward compatibility
const OLD_STEP_MAP: Record<string, StepId> = {
  "0": "subjects",
  "1": "tutoring-options",
  "2": "tutor-profile",
  "3": "qualifications",
  "4": "contact-info",
  "5": "subscription",
  "6": "submit",
};

export function useStepper() {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  let stepParam = params.get("step") as string | null;

  // Convert old numeric step to new step ID for backward compatibility
  if (stepParam && OLD_STEP_MAP[stepParam]) {
    stepParam = OLD_STEP_MAP[stepParam];
    // Update URL to use new format
    const newParams = new URLSearchParams(location.search);
    newParams.set("step", stepParam);
    navigate({ pathname: location.pathname, search: newParams.toString() }, { replace: true });
  }

  const all = stepsConfig;
  const currentIndex = Math.max(
    0,
    all.findIndex((s) => s.id === (stepParam as StepId))
  );

  const step = all[currentIndex] ?? all[0];

  const setStep = (idx: number) => {
    const safe = Math.min(Math.max(idx, 0), all.length - 1);
    const next = new URLSearchParams(location.search);
    next.set("step", all[safe].id);
    navigate({ pathname: location.pathname, search: next.toString() }, { replace: true });
  };

  return useMemo(
    () => ({
      steps: all,
      index: currentIndex,
      step,
      setStep,
      next: () => setStep(currentIndex + 1),
      prev: () => setStep(currentIndex - 1),
    }),
    [currentIndex, location.key]
  );
}


